import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/auth.hook';
import { getLearningCenterAccessDeniedMessage } from '@/utils/learningCenterAccessDeniedMessages';
import headerlogo from '../../theme/svg/MyMetabolon-color.svg';
import './Login.scss';

/**
 * Shown when Auth0 redirects academy (TalentLMS SAML) users after learning-center/authorize denies access.
 */
const LearningCenterAccessDenied = () => {
	const location = useLocation();
	const auth = useAuth();
	const params = new URLSearchParams(location.search);
	const message = getLearningCenterAccessDeniedMessage(params.get('reason'));

	const goToPortalHome = () => {
		void auth.logout('/');
	};

	return (
		<div className="OuterContainer" data-testid="learning-center-access-denied">
			<div className="LogoHeader">
				<img src={headerlogo} alt="Metabolon" />
			</div>
			<div
				className="LoadingMessage"
				style={{
					textAlign: 'center',
					padding: '2rem',
					fontSize: '1.2rem',
					color: '#333',
				}}
			>
				<h1 style={{ fontSize: '1.4rem', marginBottom: '1rem', fontWeight: 600 }}>
					Learning Center sign-in unavailable
				</h1>
				<p style={{ color: '#d32f2f', marginBottom: '1.5rem', maxWidth: '600px', margin: '0 auto 1.5rem' }}>
					{message}
				</p>
				<div style={{ marginTop: '1rem' }}>
					<button
						type="button"
						onClick={goToPortalHome}
						style={{
							display: 'inline-block',
							padding: '0.5rem 1rem',
							fontSize: '1rem',
							backgroundColor: '#0066cc',
							color: 'white',
							border: 'none',
							borderRadius: '4px',
							cursor: 'pointer',
							marginRight: '0.5rem',
						}}
					>
						Go to Portal home
					</button>
				</div>
			</div>
		</div>
	);
};

export default LearningCenterAccessDenied;
